import { useEffect, useState } from 'react';
import { t, Trans } from '@lingui/macro';
import DataTable from '../../data-table/DataTable';
import { useQueryLoader } from '../../data-table/Loaders';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import {
    AGENT_EVENT_CAUSE_FIELD,
    AGENT_EVENT_IP_FIELD,
    AGENT_EVENT_SEVERITY_FIELD,
    AGENT_EVENT_TEST_TIME_FIELD,
    AGENT_EVENT_TYPE_FIELD,
    AGENTS_FUNCTION_NAME,
} from './AgentConstants';
import { dateTimeFormatter } from '../../../utilities/FormattingUtilities';
import { getTrendsTimeRange, TIME_RANGE_8_HOURS_OPTION } from './AgentHealthHelper';
import FormSection from '../../form/FormSection';
import { SORT_DESC } from '../../../utilities/FormUtilities';

function buildEventDataSource(agent) {
    const time = getTrendsTimeRange(TIME_RANGE_8_HOURS_OPTION);
    return {
        url: '/query/chart/tableview',
        totalProperty: 'count',
        dataProperty: 'data',
        params: {
            ...time,
            agent: agent._id,
            type: 'agent',
            metrics: `${AGENT_EVENT_TYPE_FIELD},${AGENT_EVENT_IP_FIELD},${AGENT_EVENT_CAUSE_FIELD},${AGENT_EVENT_SEVERITY_FIELD}`,
        },
    };
}

const columns = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Date`,
        sortable: true,
        mapping: AGENT_EVENT_TEST_TIME_FIELD,
        formatter: dateTimeFormatter,
        width: 215,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Address`,
        sortable: true,
        mapping: AGENT_EVENT_IP_FIELD,
        width: 140,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Severity`,
        sortable: true,
        mapping: AGENT_EVENT_SEVERITY_FIELD,
        width: 95,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Event Type`,
        sortable: true,
        mapping: AGENT_EVENT_TYPE_FIELD,
        flex: 1,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Cause`,
        sortable: true,
        mapping: AGENT_EVENT_CAUSE_FIELD,
        flex: 1,
    },
];

const defaultVisibleRows = 8;
const gridId = `${AGENTS_FUNCTION_NAME}-health-events`;
const initialSort = [{ property: AGENT_EVENT_TEST_TIME_FIELD, direction: SORT_DESC }];

export default function AgentHealthEvents({ agent, timeRange }) {
    const [dataSource, setDataSource] = useState(buildEventDataSource(agent));
    const eventsLoader = useQueryLoader(dataSource, { disableFilterState: true });

    useEffect(() => {
        const time = getTrendsTimeRange(timeRange);
        setDataSource((previousDataSource) => {
            return {
                ...previousDataSource,
                params: {
                    ...previousDataSource.params,
                    start: time.start,
                    end: time.end,
                },
            };
        });
    }, [timeRange, agent]);

    return (
        <FormSection title={<Trans>Events</Trans>} addSpacer>
            <DataTable
                tableId={gridId}
                showToolbar={false}
                loader={eventsLoader}
                columns={columns}
                sorters={initialSort}
                disableCSVExport
                disableColumnRemover
                visibleRows={defaultVisibleRows}
            />
        </FormSection>
    );
}
